<template>
<div class="input-form-container">
	<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
	<div>
		<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
		<div v-if="showComponent" transition="router-anim" class="container main-content">
			<div class="text-center mb-5" v-if="showSelectTab">
				<button v-if="$gstate.getInputBuyAllowed()" v-bind:class="[activeTab == 'BUY' ? 'input-tab-active mr-3 no-focus' : 'input-tab mr-3 no-focus']" @click="setActiveTab('BUY')">Buy Bitcoin</button><button v-if="$gstate.getInputSellAllowed()" v-bind:class="[activeTab == 'SELL' ? 'input-tab-active mr-3 no-focus' : 'input-tab mr-3 no-focus']" @click="setActiveTab('SELL')">Sell Bitcoin</button><button v-if="$gstate.getInputSpendAllowed()" v-bind:class="[activeTab == 'SPEND' ? 'input-tab-active ml-3 no-focus' : 'input-tab ml-3 no-focus']" @click="setActiveTab('SPEND')">Buy eGift Cards</button>
			</div>
			<div class="row">
				<div class="col-12">
					<form class="input-form text-center" onkeydown="return event.key != 'Enter';">
						<div v-if="activeTab == 'BUY'">
							<div class="form-group spend-input pb-2">
								<span>I want to spend {{ $gstate.getCurrencySymbol(this.fiatCurrency) }}</span><input id="amount" class="amount-input no-focus form-control no-border-radius inline text-center pb-0" type="number" ref="amount"
									v-model="in_amount" 
									v-bind:class="{'is-invalid': hasError}"
									v-on:keydown.enter="validateInputForm"
									/>
									<template v-if="$gstate.getNumSupportedFiatCurrencies() == 1">
										<span>{{ this.fiatCurrency }} to buy</span>
									</template>
									<template v-else>
										<select id="fiatCurrency" v-model="fiatCurrency" v-on:change="updateFiatCurrency" class="form-control fiat-select inline ml-3">
											<option v-for="(option, index) in $gstate.getSupportedFiatCurrencies()" :value="index" v-bind:key="index">{{ index }}</option>
										</select>
									</template>
							</div>

							<div class="form-group">
								<template v-if="$gstate.getNumSupportedCoins() == 1">
									<span class="input-one-option">{{ this.cryptocurrency }}</span>
								</template>
								<template v-else>
									<select id="cryptocurrency" v-model="cryptocurrency" class="form-control crypto-select inline">
										<option v-for="(option, index) in $gstate.getSupportedCoins()" :value="index" v-bind:key="index">{{ option.name }}</option>
									</select>	
								</template>

								<span class="pl-2 pr-2 pl-md-4 pr-md-4">using</span>

								<template v-if="$gstate.getNumBuyPaymentMethods() == 1">
									<span class="input-one-option">{{ $gstate.getPaymentMethodName(this.paymentMethod) }}</span>
								</template>
								<template v-else>
									<select id="paymentMethod" v-model="paymentMethod" class="form-control form-control inline">
										<option v-for="(option, index) in $gstate.getBuyPaymentMethods()" :value="index" v-bind:key="index">{{ option.name }}</option>
									</select>			
								</template>
								
							</div>
						</div>

						<div v-if="activeTab == 'SELL'">
							<div class="form-group spend-input pb-2">
								<span>I want to sell </span><input id="cryptoamount" class="amount-input no-focus form-control no-border-radius inline text-center pb-0 mr-3" type="number" step=".0001" ref="cryptoamount"
									v-model="in_amount" 
									v-bind:class="{'is-invalid': hasError}"
									v-on:keydown.enter="validateInputForm"
									/>
									<template v-if="$gstate.getNumSupportedCoins() == 1">
										<span class="input-one-option">{{ this.cryptocurrency }}</span>
									</template>
									<template v-else>
										<select id="cryptocurrency" v-model="cryptocurrency" v-on:change="updateCryptoCurrency" class="form-control crypto-select inline">
											<option v-for="(option, index) in $gstate.getSupportedCoins()" :value="index" v-bind:key="index">{{ option.name }}</option>
										</select>	
									</template>
									
							</div>

							<div class="form-group">

								<span class="pl-2 pr-2 pl-md-4 pr-md-4">using</span>
								<template v-if="$gstate.getNumSellPaymentMethods() == 1">
									<span class="input-one-option">{{ $gstate.getPaymentMethodName(this.paymentMethod) }}</span>
								</template>
								<template v-else>
									<select id="paymentMethod" v-model="paymentMethod" class="form-control form-control inline">
										<option v-for="(option, index) in $gstate.getSellPaymentMethods()" :value="index" v-bind:key="index">{{ option.name }}</option>
									</select>			
								</template>
								
							</div>
						</div>

						<div v-if="activeTab == 'SPEND'">
					
							<div class="form-group spend-input pt-4">
								<span>I want to spend</span>
								<select id="cryptocurrency" v-model="cryptocurrency" class="form-control crypto-select inline ml-2 mr-2">
									<option v-for="(option, index) in $gstate.getSupportedCoins()" :value="option.id" v-bind:key="index">{{ option.name }}</option>
								</select>
								<span>to buy an eGift Card.</span>
							</div>

							<div class="form-group">
								<label for="paymentMethod">Select eGift Card</label>
								<select id="paymentMethod" v-model="paymentMethodSubtype" class="form-control gift-card-select mt-1">
									<option v-for="(option, index) in $gstate.getPaymentMethodSubtypes()" :value="index" v-bind:key="index">{{ option.name }}</option>
								</select>
							</div>
						</div>

					</form>
					
				</div>
			</div>
			
			<div class="row mt-5 mb-5">
				<div class="col-12 text-center">
					<small class="error" v-if="hasError">{{ errorMessage }}</small>
				</div>
			</div>
					
			<div class="row mt-5">
				<div class="col-12 text-center">
					<a href="#" id="address-input-next" class="btn next-btn"  v-if="!isProcessing" v-on:click.prevent="validateInputForm">NEXT</a>
					<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">PLEASE WAIT... <i class="fas fa-circle-notch fa-spin"></i></a>
				</div>
			</div>
			
			
		</div>
		</transition>
		<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
		<div v-if="!showComponent" class="vertical-center getting-quote">
			<div class="container main-content">
				<div class="row text-center">
					<div class="col-12">
						<template v-if="paymentMethod == 'CREDITCARD' && $gstate.getPaymentMethodObj(paymentMethod).action != undefined && $gstate.getPaymentMethodObj(paymentMethod).action == 'URL'">
							Saving quote... <i class="fas fa-circle-notch fa-spin"></i>
						</template>
						<template v-else>
							Getting quote... <i class="fas fa-circle-notch fa-spin"></i>
						</template>
					</div>
				</div>
			</div>
		</div>
		</transition>
	</div>
	</transition>
</div>
</template>

<script>

import { eventBus } from './../main'

export default {
	data() {
		return {
			showComponent: true,
			in_amount: 0,
			isProcessing: false,
			hasError: false,
			errorMessage: '',
			cryptocurrency: this.$gstate.getDefaultSupportedCoin().id,	// default option
			paymentMethod: 'ETRANSFER',	// default option
			paymentMethodSubtype: 'AMAZON',
			fiatCurrency: this.$gstate.getDefaultSupportedFiatCurrency().id,	// default option
			txnType: '',
			failedCount: 0,
			timeout: null,
			activeTab: '',
			defaultActiveTab: 'BUY'
		}
	},
	computed: {
		showSelectTab(){

			var score = 0
			if(this.$gstate.getInputBuyAllowed()){
				score++;
			}

			if(this.$gstate.getInputSpendAllowed()){
				score++;
			}

			if(this.$gstate.getInputSellAllowed()){
				score++;
			}

			if(score > 1){
				return true;
			}


			return false;
		},
		activeUsers: function() {
			return this.users.filter(function(u) {
				return u.active
			})
		}
	},
	mounted() {

		this.$gstate.init();
		this.$emit('setLeaveNotification', false);
		this.$emit('setRateHoldTimer', false);

		if(this.showSelectTab){
			this.setActiveTab('BUY');
		}

		this.setActiveTab(this.defaultActiveTab);
	},
	created(){

		if(!this.$gstate.getInputAllowed()){
			this.showComponent = false;
			this.$gstate.redirectHome('', 200, 'input not allowed');
		}

		this.updateFiatCurrency();
		this.updateCryptoCurrency();

		eventBus.$on('nextScreen', this.validateInputForm);
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.validateInputForm);
	},
	
	methods: {
		setActiveTab: function (param){

			this.activeTab = param;
			this.hasError = false;

			if(param == 'BUY'){
				this.txnType = 'BUY';
				this.in_amount = this.$gstate.getDefaultBuyAmount()
				this.paymentMethod = this.$gstate.getDefaultBuyPaymentMethod();
			} else if (param == 'SELL'){
				this.txnType = 'SELL';
				this.in_amount = this.$gstate.getDefaultSellAmount()
				this.paymentMethod = this.$gstate.getDefaultSellPaymentMethod();
			} else if (param == 'SPEND'){
				this.txnType = 'SELL';
				this.in_amount = parseInt(this.$gstate.getPaymentMethodSubtypeAmounts(this.paymentMethodSubtype)[0]);
				this.paymentMethod = 'GIFTCARD';
			}

			this.$gstate.setTxnType(this.txnType);

		},
		validateInputForm: function(){
			if(this.txnType == 'BUY' || this.paymentMethod == 'GIFTCARD'){
				this.validateBuyInputForm();
			} else if (this.txnType == 'SELL') {
				this.validateSellInputForm();
			}
		},
		validateBuyInputForm(){
			// if action is found, do the action.  otherwise proceed as normal
			if(this.$gstate.getPaymentMethodObj(this.paymentMethod) !== undefined && this.$gstate.getPaymentMethodObj(this.paymentMethod).action !== undefined){
				this.doAction(this.$gstate.getPaymentMethodObj(this.paymentMethod))
				return;
			}

			if(this.$gstate.getSupportedCoin(this.cryptocurrency) !== undefined && this.$gstate.getSupportedCoin(this.cryptocurrency).action !== undefined){
				this.doAction(this.$gstate.getSupportedCoin(this.cryptocurrency))
				return;
			}

			this.hasError = false;
			if (this.in_amount < this.$gstate.getMinAmount(this.txnType, this.paymentMethod)) {
				this.errorMessage = 'Amount must be greater than $'+ this.$gstate.getMinAmount(this.txnType, this.paymentMethod) +'.';
				this.hasError = true;
				return;
			}

			if (this.in_amount > this.$gstate.getMaxAmount(this.txnType, this.paymentMethod)) {
				this.errorMessage = 'Amount must be less than $'+ this.$gstate.getMaxAmount(this.txnType, this.paymentMethod) +'.';
				this.hasError = true;
				return;
			}

			this.showComponent = false;
			this.failedCount = 0;

			if(this.paymentMethod == 'CREDITCARD'){
				
				this.$gstate.saveFlowState({
					fiatAmount: this.in_amount,
					cryptoCurrency: this.cryptocurrency,
					fiatCurrency: this.fiatCurrency
				});

				this.$router.push('/credit-card-quote');
				return;

			} else {
				this.getQuote();
			}
		},
		validateSellInputForm(){

			this.hasError = false;
			if (this.in_amount < this.$gstate.getMinAmount(this.txnType, this.paymentMethod)) {
				this.errorMessage = 'Amount must be greater than '+ this.$gstate.getMinAmount(this.txnType, this.paymentMethod) + ' ' + this.$gstate.getActiveCryptoCurrency() + '.';
				this.hasError = true;
				return;
			}

			if (this.in_amount > this.$gstate.getMaxAmount(this.txnType, this.paymentMethod)) {
				this.errorMessage = 'Amount must be less than '+ this.$gstate.getMaxAmount(this.txnType, this.paymentMethod) + ' ' + this.$gstate.getActiveCryptoCurrency() + '.';
				this.hasError = true;
				return;
			}

			this.showComponent = false;
			this.failedCount = 0;

			this.getQuote();
		},
		doAction(object){

			this.isProcessing = true;
			if(object.action == 'URL'){
				window.location.href = object.url;
			}
		},
		updateFiatCurrency(){
			this.$gstate.setActiveFiatCurrency(this.fiatCurrency);
		},
		updateCryptoCurrency(){
			this.$gstate.setActiveCryptoCurrency(this.cryptocurrency);
		},
		getQuote: function() {
			
			this.isProcessing = true;
			this.hasError = false;
			if (this.in_amount <= 0) {
				// technically no screen to show these errors on so just redirect to home
				this.errorMessage = 'Amount must be greater than zero.';
				this.hasError = true;
				this.$gstate.redirectHome('', 200, this.errorMessage);
				return;
			}

			if(!this.$gstate.isValidPaymentMethod(this.paymentMethod)){
				// technically no screen to show these errors on so just redirect to home
				this.errorMessage = 'Payment method not found.'
				this.hasError = true;
				this.$gstate.redirectHome('', 200, this.errorMessage);
				return;
			}

			var browserResolution = window.screen.width + "x" + window.screen.height;

			var data = {
					fiatAmount: this.in_amount,
					fiatCurrency: this.fiatCurrency,
					cryptoCurrency: this.cryptocurrency,
					paymentMethod: this.paymentMethod,
					txnType: this.txnType,
					browserResolution: browserResolution,
					country: this.$gstate.getActiveCountry()
				};

			if(this.txnType == 'BUY'){
				data.fiatAmount = this.in_amount;
				data.cryptoAmount = 0;
			} else if (this.txnType == 'SELL') {

				if(this.paymentMethod == 'GIFTCARD'){
					data.fiatAmount = this.in_amount;
					data.cryptoAmount = 0;
					data.paymentMethodSubtype = this.paymentMethodSubtype;
					this.$gstate.setPaymentMethodSubtype(this.paymentMethodSubtype);
				} else {
					data.fiatAmount = 0;
					data.cryptoAmount = this.in_amount;
				}
				
			}


			this.$gstate.log("processing quote...");
			var urlstr = this.$gstate.getApiBaseURL() + '/quoterequest';
			this.axios.post(urlstr, data, this.$gstate.getAxiosHeaders())
				.then(response => {

					this.$gstate.saveFlowStateAndProceed(response.data, this);

				})
				.catch(error => {
					this.$gstate.log(error.response);


					if(error.response.data.error.msg != undefined){
						this.showComponent = true;
						this.hasError = true;
						this.isProcessing = false;
						this.errorMessage = error.response.data.error.msg;
						return;
					}

					// try again in 5 seconds
					this.$gstate.log("price quote failed");

					this.timeout = setTimeout(() => {
						
						this.$gstate.log("trying again...");

						if(this.failedCount >= 5){
							this.$gstate.redirectHome(200, 0, 'process payment failed');
							
						} else {
							this.failedCount++;
							this.getQuote();
						}

						
					}, 5000);
					
				});
		}
	}
}

</script>